import { useState, FC } from 'react';
import { Audio } from 'types/audio';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';

export interface DeleteSongContributionDialogProps {
  audio?: Audio;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const DeleteSongAudioDialog: FC<DeleteSongContributionDialogProps> = ({
  audio,
  onClose,
  onConfirm,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onConfirm();
      setLoading(false);
      onClose();
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <ChakraConfirmationDialog
      title="Delete Audio"
      message={`Are you sure you want to delete the audio file "${audio?.title}"? Once deleted, it’s gone forever.`}
      actionButtonText="Delete"
      isOpen={Boolean(audio)}
      handleAction={handleDelete}
      onClose={onClose}
      disableSubmitAction={loading}
    />
  );
};
